import stylesheet from './ContentItemList.scss?inline';

import CustomComponent from '../../base/customComponent/CustomComponent';

export class NXTContentItemList extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add('content-item-list');
        container.innerHTML = `<slot></slot>`;
        return container;
    }
}

customElements.define('nxt-content-item-list', NXTContentItemList);
